import type { DatasetGpsProps } from "./dataset-gps.type";

import { DatasetCard } from "@/modules/dataset/dataset-card";

import DatasetGpsEditor from "./dataset-gps-editor";

const DatasetGps = ({
  template,
  dataset,
  loading,
  disabled,
}: DatasetGpsProps) => {
  return (
    <DatasetCard
      datasetType="gps"
      template={template}
      dataset={dataset}
      loading={loading}
      disabled={disabled}
    >
      <DatasetGpsEditor
        disabled={disabled}
        dataset={dataset}
        template={template}
      />
    </DatasetCard>
  );
};

export default DatasetGps;
